var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.label))]),_c('treeselect',{attrs:{"name":_vm.name,"multiple":_vm.multiple,"options":_vm.treeOptions,"value":_vm.treeValue,"showCount":_vm.showCount,"clearable":_vm.clearable,"disabled":_vm.disabled},on:{"change":_vm.handleChange,"input":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }